<template>
  <div class="overflow-hidden rounded-lg bg-white shadow">
    <div class="px-4 py-5 sm:p-6">
      <div class="sm:flex sm:items-center">
        <div class="sm:flex-auto">
          <h1 class="text-base font-semibold leading-6 text-gray-900">Email templates</h1>
          <p class="mt-2 text-sm text-gray-700">A list of all the Email templates.</p>
        </div>

        <div class="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
        </div>

        <div class="mt-4 sm:mt-0 ml-2 sm:flex-none">
        </div>

      </div>
      <SearchComponent @setSearchText="setSearchText"/>
      <div class="mt-8 flow-root">
        <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">

          <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <table class="min-w-full divide-y divide-gray-300">
              <thead>
              <tr>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900 sm:pl-0">ID</th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900">Name</th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900">Type</th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900">Updated at</th>
                <th scope="col" class="px-3 py-1 text-right text-sm font-semibold text-gray-900">Options</th>
              </tr>
              </thead>
              <tbody class="divide-y divide-gray-200">
              <tr v-for="item in items" :key="item.id">
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.id }}</td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.name }}</td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.type }}</td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.updated_at }}</td>

                <td class="py-1 pl-3 text-sm font-medium sm:pr-0">
                  <div class="flex items-center justify-end gap-x-0">
                    <RouterLink :to="{ name: 'EmailTemplateShow', params: { id: item.id } }" class="network-button-color hover:text-gray-900">
                      <EyeIcon class="m-1 h-6 w-6" aria-hidden="true" />
                    </RouterLink>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <PaginationComponent :response="meta" @setPage="getItems"></PaginationComponent>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationComponent from "../TwPaginationComponent.vue";
import {EyeIcon} from "@heroicons/vue/20/solid";
import SearchComponent from "../SearchComponent.vue";

export default {
  name: "EmailTemplateIndexComponent",
  props: {
    accountId: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      items: [],
      meta: {},
      page: null,
      thisPage: null,
      searchText: null,
      selectedFilter: '',
    }
  },
  components: {
    PaginationComponent,
    EyeIcon,
    SearchComponent,
  },
  watch: {
    searchText: {
      handler(newValue, oldValue) {
        this.getItems();
      },
      deep: true
    },
  },
  computed: {
    isAuditor() {
      return this.$store.state.userIsAuditor;
    },
  },
  methods: {
    setSearchText(value) {
      this.searchText = value;
    },
    getItems(page = null) {
      this.thisPage = page;
      axios.get(`/member-firm/email-templates/index?page=${page}`, {params: {'search_text': this.searchText, 'selected_filter': this.selectedFilter}}).then((res) => {
        this.items = res.data.data;
        this.meta = res.data.meta;
      }).catch((error) => {
        console.log('error', error)
      })
    },
  },
  created() {
    this.getItems();
  },
}
</script>